<template>
  <v-container>
    <v-dialog v-model="dialogCancelHour" max-width="600px">
      <v-card>
        <v-card-title>
          <v-icon color="error" style="margin-right: 16px;">warning</v-icon>
          <span>Cancelar cita</span>
        </v-card-title>
        <div style="margin: 16px">
          <p>¿Estás seguro de cancelar la cita seleccionada?</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCancelHour = false">Volver</v-btn>
          <v-btn color="error" @click="cancelHour">Cancelar cita</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancelHourSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">La cita se canceló correctamente</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogCancelHourSuccess = false" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancelHourError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">No se ha podido cancelar la cita</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogCancelHourError = false;" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-subheader>
      <span class="primary--text">Vigentes</span>
    </v-subheader>

    <v-list>
      <div class="d-flex justify-center" v-if="!currentHourList">
        <span class="font-weight-light">Cargando...</span>
      </div>
      <div class="d-flex justify-center" v-if="currentHourList && !currentHourList.length">
        <span class="font-weight-light">No tienes citas vigentes</span>
      </div>
      <v-list-item v-for="item in currentHourList" v-bind:key="item.id">
        <v-list-item-avatar>
          <professional-avatar v-bind:id-professional="(item.booking.professional || {}).id"></professional-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{(item.booking.professional || {}).fullName}}</v-list-item-title>
          <v-list-item-subtitle>{{(item.booking.specialty || {}).name}}</v-list-item-subtitle>
          <v-list-item-subtitle>{{item.date}} a las {{item.start}}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon @click="openDialogCancelHour(item)" color="red">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-subheader>
      <span class="primary--text">Anteriores</span>
    </v-subheader>
    <v-list>
      <div class="d-flex justify-center" v-if="!hourList">
        <span class="font-weight-light">Cargando...</span>
      </div>
      <div class="d-flex justify-center" v-if="hourList && !hourList.length">
        <span class="font-weight-light">No tienes citas anteriores</span>
      </div>
      <v-list-item v-for="item in hourList" v-bind:key="item.id">
        <v-list-item-avatar>
          <professional-avatar v-bind:id-professional="(item.booking.professional || {}).id"></professional-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{(item.booking.professional || {}).fullName}}</v-list-item-title>
          <v-list-item-subtitle>{{(item.booking.specialty || {}).name}}</v-list-item-subtitle>
          <v-list-item-subtitle>{{item.date}} a las {{item.start}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
export default {
  name: "History",
  props: {
    msg: String
  },
  data: () => ({
    idPatient: 5,
    hourList: null,
    currentHourList: null,
    dialogCancelHour: false,
    hourSelected: null,
    cancelHourSuccessMessage: false,
    dialogCancelHourSuccess: false,
    dialogCancelHourError: false,
    dialogDetailsHour: false
  }),
  methods: {
    openDialogCancelHour: function(hourSelected) {
      this.hourSelected = hourSelected;
      this.dialogCancelHour = true;
    },
    opendialogDetailsHour: function(hourSelected) {
      this.hourSelected = hourSelected;
      this.dialogDetailsHour = true;
    },
    async cancelHour() {
      this.dialogCancelHour = false;
      try {
        const axios = require("axios");
        await axios.post("cancelHour", {
          idHour: this.hourSelected.id
        });
        this.currentHourList = this.currentHourList.filter(
          ({ id }) => id !== this.hourSelected.id
        );
        this.dialogCancelHourSuccess = true;
      } catch (err) {
        this.dialogCancelHourError = true;
        console.log(err);
      }
    },
    getData: function() {
      const axios = require("axios");
      axios.get("getMyHourList").then(
        res => {
          this.currentHourList = res.data
            .filter(({ vigente }) => vigente)
            .sort((a, b) =>
              new Date(a.fullDate) > new Date(b.fullDate) ? 1 : -1
            );
          this.hourList = res.data.filter(({ vigente }) => !vigente);
        },
        err => {
          console.log(err);
          this.currentHourList = [];
          this.hourList = [];
        }
      );
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "Mis citas") {
        this.getData();
      }
    }
  },
  created: function() {
    this.getData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
